<div class="datatable-header-cell-wrapper d-flex flex-row align-items-center mb-1">
  <div class="datatable-header-cell-label text-black flex-grow-1"
       style="cursor: pointer"
       [ngbTooltip]="column.description"
       [placement]="['top-left','top-right']"
       container="body"
       (click)="emitSort()">
    <i *ngIf="sortDir"
       class="fa-light"
       [class.fa-arrow-down-long]="sortDir === 'desc'"
       [class.fa-arrow-up-long]="sortDir === 'asc'">
    </i>
    {{column.name}}
  </div>
</div>
<asax-result-table-vo-table-column-header-filter-input [column]="column"
                                                       (outColumnFilter)="onColumnFilter($event)">
</asax-result-table-vo-table-column-header-filter-input>
